export const GET_ROASTERS = 'roasters/GET_ROASTERS';
export const GET_ROASTERS_SUCCESS = 'roasters/GET_ROASTERS_SUCCESS';
export const GET_ROASTERS_FAILED = 'roasters/GET_ROASTERS_FAILED';